/**
 * Resolves the setup fee rate shown to customers.
 *
 * ERHL loans only charge the base set-up fee, while bridging loans surface a
 * total that also includes any broker and referral fees.
 *
 * @param {{ setupFeeRate?: number, brokerFee?: number, referralFee?: number }} calculatedValue
 * @param {boolean} isErhl
 * @returns {number} rate as a decimal fraction (e.g. 0.0275)
 */
export function getSetupFeeRate(calculatedValue, isErhl) {
  const toPositiveNumber = (value) => (Number(value) > 0 ? Number(value) : 0);
  const setupFeeRate = Number(calculatedValue?.setupFeeRate) || 0;

  if (isErhl) {
    return setupFeeRate;
  }

  return setupFeeRate + toPositiveNumber(calculatedValue?.brokerFee) + toPositiveNumber(calculatedValue?.referralFee);
}
